import type { ColliderDef } from './colliderTypes';

/**
 * Default colliders for the Muzdalifah scene.
 * Hollow cylinder defines the scene boundary — camera stays inside.
 */
export const MUZDALIFA_DEFAULT_COLLIDERS: ColliderDef[] = [
  {
    id: 'scene-boundary',
    type: 'cylinder',
    mode: 'hollow',
    enabled: true,
    blocksLineOfSight: false,
    "position": {
      "x": -1.6097442003738163,
      "y": 0.12910308084061667,
      "z": 0.2794973600226701
    },
    "radius": 7,
    "height": 18.459999999999997
  },
];
